import { render, staticRenderFns } from "./99.vue?vue&type=template&id=5a063be2&scoped=true&"
import script from "./99.vue?vue&type=script&lang=js&"
export * from "./99.vue?vue&type=script&lang=js&"
import style0 from "./99.vue?vue&type=style&index=0&id=5a063be2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a063be2",
  null
  
)

export default component.exports